import {Button, Grid, MenuItem, Paper, TextField, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import SectionHeader from '../../../../../util/component/SectionHeader';
import {useRecoilState} from 'recoil';
import {
    CUSTOMER_SELECTED_MOBILITY,
    ORDER_SELECTED,
    STEPPER_STATE,
    SUBSCRIPTION_SELECTED
} from '../../../service/MobilityVoucherRecoil';
import {useVoucherActions} from '../../../service/useMobilityVoucherAction';
import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {GlobalContext} from '../../../../../util/state/GlobalContextProvider';
import {snackbarTypes} from '../../../../../util/state/globalVariables';
import {Controller, useForm} from 'react-hook-form';
import {ArrowBack} from "@mui/icons-material";
import CustomModal from "../modals/CustomModal";
import {CORRELATION_NAME_PBL, EMAIL, SMS} from "../../../interfaces/Order";
import {setSnackbar} from "../../../../../util/state/globalAction";
import {useNavigate} from "react-router-dom";
import FormAsyncAutocomplete from "../../../component/common/FormAsyncAutocomplete";

const SummaryStep = () => {
    const {t} = useTranslation(['mobilityvoucher']);

    const [customer, setCustomer] = useRecoilState(CUSTOMER_SELECTED_MOBILITY);
    const [subscription, setSubscription] = useRecoilState(SUBSCRIPTION_SELECTED);
    const [activeStep, setActiveStep] = useRecoilState(STEPPER_STATE);
    const [order, setOrder] = useRecoilState(ORDER_SELECTED);
    const {saveOrder, createPayByLink} = useVoucherActions();
    const {globalData, dispatchGlobalData} = useContext(GlobalContext);
    const [items, setItems] = useState<any>([]);
    const [openPaymentMethodModal, setOpenPaymentMethodModal] = useState(false);
    const [openPaymentPayByLinkModal, setOpenPaymentPayByLinkModal] = useState(false);
    const [showEmailSMS, setShowEmailSMS] = useState(false);
    const [proceed, setProceed] = useState(false);
    const [byPos, setByPos] = useState(false);
    const [payByLinkChannel, setPayByLinkChannel] = useState("");
    const [dmsNumber, setDmsNumber] = useState(0);
    const [focusStoreSelect, setFocusStoreSelect] = useState<boolean>(false);
    const navigate = useNavigate();
    type ButtonVariant = 'text' | 'outlined' | 'contained';

    const [buttonVariants, setButtonVariants] = useState<{
        buttonPos: ButtonVariant,
        buttonPay: ButtonVariant,
        buttonEmail: ButtonVariant,
        buttonSMS: ButtonVariant,
    }>({
        buttonPos: 'outlined',
        buttonPay: 'outlined',
        buttonEmail: 'outlined',
        buttonSMS: 'outlined',
    });


    const handleClick = (buttonId: keyof typeof buttonVariants) => {
        setButtonVariants({
            buttonPos: 'outlined',
            buttonPay: 'outlined',
            buttonEmail: 'outlined',
            buttonSMS: 'outlined',
            [buttonId]: 'contained'
        } as typeof buttonVariants);

    };

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user') || 'null');
        if (items) {
            const itemsFiltered = items.mobilityStores.filter((i: any) => i.id !== 0 && i.tenant === subscription[0].tenantId);
            setItems(itemsFiltered);
        }

    }, []);

    const filterDefaultValues: any = {
        dms: ''
    };


    const [filters, setFilters] = useState<any>(filterDefaultValues);
    const [isDisabled, setIsDisabled] = useState(true);

    const {handleSubmit, control, formState: {isValid}} = useForm({
    defaultValues: filterDefaultValues });


    const handleNext = async (el: any) => {

        const bodyMS = items.filter((i: any) => i.id === el)
        console.log('el', bodyMS);

        const newOrder = {
            subscription: subscription[0],
            customer: customer[0],
            mobilityStore: {
                id: bodyMS[0].id,
                sapId: bodyMS[0].sapId,
                identificationCode: bodyMS[0].identificationCode,
                name: bodyMS[0].name
            },
            "sameAddressForBilling": true
        };

        if (checkOrderValidation()) {
            saveOrder(newOrder).then(
                (res) => {
                    if (res) {
                        setOrder(res)
                        setActiveStep((prevActiveStep: number) => prevActiveStep + 1);
                    }
                }
            );
        }
    };

    const handleNextPBL = (el: any) => {

        const bodyMS = items.filter((i: any) => i.id === el)
        console.log('el', bodyMS);

        const newOrder = {
            subscription: subscription[0],
            customer: customer[0],
            mobilityStore: {
                id: bodyMS[0].id,
                sapId: bodyMS[0].sapId,
                identificationCode: bodyMS[0].identificationCode,
                name: bodyMS[0].name
            },
            "sameAddressForBilling": true
        };

        if (checkOrderValidation()) {
            saveOrder(newOrder).then(
                (res) => {
                    if (res) {
                        payByLink(res)
                    }
                }
            );
        }
    };

    function payByLink(res: any) {

        const payByLink = {
            sku: subscription[0].sku,
            channel: payByLinkChannel,
            amount: parseFloat(subscription[0].entryFee),
            customerId: customer[0].bpCode,
            orderId: res.id,
            correlationId: res.id,
            correlationName: CORRELATION_NAME_PBL + res.id,
            dealerId: subscription[0].dealerId,
            tenantId: subscription[0].tenantId
        }


        createPayByLink(payByLink).then(
            (res) => {
                if (res) {
                    setOrder(res)
                    navigate("/mobilityvoucher/orders")
                } else {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: t('mobilityvoucher:message.payByLinkError'),
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true,
                            }
                        }
                    });
                }
            }
        );
    }

    function checkOrderValidation() {
        if (!customer[0].email) {
            dispatchGlobalData({
                type: 'SET_SNACKBAR',
                payload: {
                    snackbar: {
                        message: t('mobilityvoucher:message.emailStepper'),
                        type: snackbarTypes.warning,
                        show: true,
                        autoClose: true,
                    }
                }
            });
            return false;
        } else if (
            ((!customer[0].billingAddress?.country || customer[0].billingAddress?.country.trim().length == 0) ||
                (!customer[0].billingAddress?.city || customer[0].billingAddress?.city.trim().length == 0) ||
                (!customer[0].billingAddress?.zipCode || customer[0].billingAddress?.zipCode.trim().length == 0) ||
                (!customer[0].billingAddress?.street || customer[0].billingAddress?.street.trim().length == 0))
        ) {
            dispatchGlobalData({
                type: 'SET_SNACKBAR',
                payload: {
                    snackbar: {
                        message: t('mobilityvoucher:message.billingAddressStepper'),
                        type: snackbarTypes.warning,
                        show: true,
                        autoClose: true,
                    }
                }
            });
            return false;
        } else if (!customer[0].bpCode) {
            dispatchGlobalData({
                type: 'SET_SNACKBAR',
                payload: {
                    snackbar: {
                        message: t('mobilityvoucher:message.sapIdStepper'),
                        type: snackbarTypes.warning,
                        show: true,
                        autoClose: true,
                    }
                }
            });
            return false;
        }
        return true;
    }

    const handleCancel = async () => {
        setActiveStep((prevActiveStep: number) => prevActiveStep - 1);
    };

    const onFormSubmit = (data: any) => {

        setFilters(data);
        setDmsNumber(Number(data.dms.key))
        setOpenPaymentMethodModal(true)
    };

    return (
        <>
            <Paper elevation={1} sx={{padding: "", margin: "18px"}}>
                <SectionHeader title={t('stepper.steps.title3')}
                               subtitle={t('stepper.steps.subtitle3')}/>

                <form style={{display: 'flex'}}>

                    <Grid sx={{margin: '18px'}} container xs={12}>
                        <Grid item xs={6}>
                            <h4>{t('mobilityvoucher:order_details.subscriptionTitle')}</h4>
                        </Grid>
                        {subscription && <Grid spacing={2} container xs={12}>
                            <Grid item xs={3}>
                                <TextField value={subscription[0].productCode} fullWidth
                                           label={t('mobilityvoucher:order_details.subscription.code')}
                                           InputProps={{readOnly: true}}/>
                            </Grid>
                            <Grid item xs={3}>
                                <TextField value={subscription[0].name} fullWidth
                                           label={t('mobilityvoucher:order_details.subscription.name')}
                                           InputProps={{readOnly: true}}/>
                            </Grid>
                            <Grid item xs={3}>
                                <TextField value={subscription[0].category} fullWidth
                                           label={t('mobilityvoucher:order_details.subscription.category')}
                                           InputProps={{readOnly: true}}/>
                            </Grid>
                            <Grid item xs={3}>
                                <TextField value={subscription[0].sku} fullWidth
                                           label={t('mobilityvoucher:order_details.subscription.sku')}
                                           InputProps={{readOnly: true}}/>
                            </Grid>

                        </Grid>
                        }

                        <Grid item xs={6}>
                            <h4>{t('mobilityvoucher:order_details.customerTitle')}</h4>
                        </Grid>
                        {customer && <Grid spacing={2} container xs={12}>
                            <Grid item xs={3}>
                                <TextField value={customer[0].lastName || ' '} fullWidth
                                           label={t('mobilityvoucher:order_details.customer.lastName')}
                                           InputProps={{readOnly: true}}/>
                            </Grid>
                            <Grid item xs={3}>
                                <TextField value={customer[0].firstName || ' '} fullWidth
                                           label={t('mobilityvoucher:order_details.customer.firstName')}
                                           InputProps={{readOnly: true}}/>
                            </Grid>
                            <Grid item xs={3}>
                                <TextField value={customer[0].taxCode || ' '} fullWidth
                                           label={t('mobilityvoucher:order_details.customer.taxCode')}
                                           InputProps={{readOnly: true}}/>
                            </Grid>
                            <Grid item xs={3}>
                                <TextField required value={customer[0].email || ''} fullWidth
                                           label={t('mobilityvoucher:order_details.customer.email')}
                                           InputProps={{readOnly: true}}/>
                            </Grid>
                        </Grid>}
                        {customer && <Grid spacing={2} container xs={12}>
                            <Grid item xs={3}>
                                <TextField value={customer[0].companyName || ' '} fullWidth
                                           label={t('mobilityvoucher:order_details.customer.companyName')}
                                           InputProps={{readOnly: true}}/>
                            </Grid>
                            <Grid item xs={3}>
                                <TextField value={customer[0].vatNumber || ' '} fullWidth
                                           label={t('mobilityvoucher:order_details.customer.vatNumber')}
                                           InputProps={{readOnly: true}}/>
                            </Grid>
                            {customer[0].siren &&
                                <Grid item xs={3}>
                                    <TextField value={customer[0].siren || ' '} fullWidth
                                               label={t('mobilityvoucher:order_details.customer.siren')}
                                               InputProps={{readOnly: true}}/>
                                </Grid>
                            }
                            {customer[0].siret &&
                                <Grid item xs={3}>
                                    <TextField value={customer[0].siret || ' '} fullWidth
                                               label={t('mobilityvoucher:order_details.customer.siret')}
                                               InputProps={{readOnly: true}}/>
                                </Grid>
                            }
                        </Grid>}
                        {customer[0].billingAddress ?
                            <>
                                <Grid item xs={6}>
                                    <h4>{t('mobilityvoucher:order_details.billingAddress')}</h4>
                                </Grid>
                                {customer && <Grid spacing={2} container xs={12}>
                                    <Grid item xs={3}>
                                        <TextField value={customer[0].billingAddress?.country || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.country')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={customer[0].billingAddress?.city || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.city')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={customer[0].billingAddress?.province || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.province')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={customer[0].billingAddress?.zipCode || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.zipCode')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                </Grid>
                                }
                                <Grid spacing={2} container xs={12}>
                                    <Grid item xs={3}>
                                        <TextField value={customer[0].billingAddress?.street || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.address')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={customer[0].billingAddress?.addressNumber || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.addressNumber')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                </Grid>
                            </>
                            :
                            <>
                                <Grid item xs={6}>
                                    <h4>{t('mobilityvoucher:order_details.address')}</h4>
                                </Grid>
                                {customer && <Grid spacing={2} container xs={12}>
                                    <Grid item xs={3}>
                                        <TextField value={customer[0].address?.country || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.country')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={customer[0].address?.city || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.city')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={customer[0].address?.province || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.province')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={customer[0].address?.zipCode || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.zipCode')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                </Grid>
                                }
                                <Grid spacing={2} container xs={12}>
                                    <Grid item xs={3}>
                                        <TextField value={customer[0].address?.street || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.address')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField value={customer[0].address?.addressNumber || ' '} fullWidth
                                                   label={t('mobilityvoucher:order_details.customer.addressNumber')}
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                </Grid>
                            </>
                        }
                        <Grid item xs={12} container display={"flex"} justifyContent={"space-between"}
                              alignItems={"center"}>
                            <Grid item xs={2}>
                                <Grid item xs={10}>
                                    <h4>{t('mobilityvoucher:order_details.order.orderTotal')}</h4>
                                </Grid>
                                {subscription && <Grid>
                                    <Grid item xs={6}>
                                        <TextField value={parseFloat(subscription[0].entryFee) / 100 + " €"} fullWidth
                                                   InputProps={{readOnly: true}}/>
                                    </Grid>
                                </Grid>}
                            </Grid>
                            <Grid item xs={2}>
                                {items &&
                                    <Grid item xs={12}>
                                        <FormAsyncAutocomplete
                                            name={'dms'}
                                            control={control}
                                            props={{
                                                initialValues: true,
                                                multiselect: false,
                                                getOptionLabel: (it) => `${it.value.identificationCode} - ${it.value.name}`,
                                                callback: () => Promise.resolve(() => {
                                                    return items.map((it: any) => {
                                                        return {key: it.id, value: it}
                                                    })
                                                }),
                                                onSelect: (option) => {
                                                    setIsDisabled(option == "")
                                                },
                                                renderInput: (params) => <TextField
                                                    {...params}
                                                    required
                                                    onFocus={() => {
                                                        setFocusStoreSelect(true);
                                                    }}
                                                    onBlur={() => setFocusStoreSelect(false)}
                                                    label={"DMS"}
                                                />
                                            }}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Paper>

            <Grid sx={{margin: '18px'}} item xs={12} display={"flex"} justifyContent={"flex-end"} mt={3}>
                <Button onClick={handleCancel} size='medium' variant="outlined"
                        sx={{mr: 1}}> {t("buttons.back")} </Button>
                <Button disabled={!customer[0].email || isDisabled} onClick={handleSubmit(onFormSubmit)}
                        size='medium'> {t("stepper.next")}</Button>
            </Grid>

            <CustomModal title={t('order_details.paymentMethod.title')}
                         content={() =>
                             <>
                                 <Grid container item display={"flex"} justifyContent={"space-evenly"}>
                                     <Button variant={buttonVariants.buttonPos} color={"accent"} size={"medium"}
                                             onClick={() => {
                                                 setProceed(true)
                                                 setByPos(true)
                                                 handleClick("buttonPos");
                                             }}>
                                         {t('order_details.paymentMethod.pos')}
                                     </Button>
                                     <Button variant={buttonVariants.buttonPay} color={"accent"} size={"medium"}
                                             onClick={() => {
                                                 setShowEmailSMS(true)
                                                 setProceed(true)
                                                 setByPos(false)
                                                 handleClick("buttonPay");
                                             }}
                                     >
                                         {t('order_details.paymentMethod.payByLink')}
                                     </Button>
                                 </Grid>

                             </>
                         }
                         cancelButton={t('order_details.paymentMethod.close')}
                         confirmButton={t('order_details.paymentMethod.proceed')}
                         callback={() => {
                             if (byPos) {
                                 handleNext(dmsNumber)
                             } else {
                                 setOpenPaymentPayByLinkModal(true)
                                 setOpenPaymentMethodModal(false)
                             }
                         }
                         }
                         disableButton={!proceed}
                         open={openPaymentMethodModal}
                         onClose={() => {
                             setProceed(false)
                             setOpenPaymentMethodModal(false);
                         }}
            />

            <CustomModal title={''}
                         titleIcon={
                             <Button color="accent" size={"small"} title={t('order_details.paymentMethod.title')}
                                     variant="text" startIcon={<ArrowBack/>}
                                     onClick={() => {
                                         setProceed(false)
                                         setOpenPaymentPayByLinkModal(false);
                                         setOpenPaymentMethodModal(true);
                                     }}>
                                 <Typography fontWeight={"bold"} color={"primary"}>
                                     {t('order_details.paymentMethod.titlePayByLink')}
                                 </Typography>
                             </Button>
                         }
                         content={() =>
                             <>
                                 <Grid container display={"flex"} justifyContent={"space-evenly"}>
                                     <Button variant={buttonVariants.buttonEmail} color={"accent"} size={"medium"}
                                             onClick={() => {
                                                 setProceed(true)
                                                 handleClick("buttonEmail");
                                                 setPayByLinkChannel(EMAIL)
                                             }}>
                                         {t('order_details.paymentMethod.email')}
                                     </Button>
                                     <Button variant={buttonVariants.buttonSMS} color={"accent"} size={"medium"}
                                             onClick={() => {
                                                 setProceed(true)
                                                 handleClick("buttonSMS");
                                                 setPayByLinkChannel(SMS)
                                             }}>
                                         {t('order_details.paymentMethod.sms')}
                                     </Button>
                                 </Grid>
                             </>
                         }
                         cancelButton={t('order_details.paymentMethod.close')}
                         confirmButton={t('order_details.paymentMethod.proceed')}
                         callback={() => handleNextPBL(dmsNumber)}
                         disableButton={!proceed}
                         open={openPaymentPayByLinkModal}
                         onClose={() => {
                             setShowEmailSMS(false)
                             setProceed(false)
                             setOpenPaymentPayByLinkModal(false);
                         }}/>

        </>
    );
};

export default SummaryStep;